import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";

export const useGetReactionsInRoom = (roomId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["reactions", "room", roomId],
    queryFn: () =>
      chatApi.getReactionsInRoom({
        roomId,
        pageIndex: 1,
        pageSize: 100, // Lấy nhiều reactions để cover hết tin nhắn
      }),
    enabled: enabled && !!roomId,
    staleTime: 30000, // Cache 30s
  });
};
